import * as React from 'react';
import cx from 'classnames';
import Dropdown, { DropDownPosition } from 'components/DropDownMenu/DropDownMenu';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import { Chevron } from 'components/Icons/Icons';
import { Link, withRouter } from 'react-router';
import defaultStyles from './Menu.css';
import { HELP_LINKS, DROP_MENU_MAX_WIDTH } from './MenuComponentConstants';
class HelpMenuDropDown extends React.Component {
    constructor(props) {
        super(props);
        this.renderLink = (item, i, styles) => {
            return (<li key={`helplinks-${i}`} className={styles['links-item']}>
				{item.openExternal ? (<a href={item.href} className={styles['link']}>
						{item.icon && <item.icon width={item.width} height={item.height}/>}
						<div className={styles['item-link']} data-aid={item['dataAid']}>
							{item.text}
						</div>
					</a>) : (<Link to={item.href} className={styles['link']}>
						{item.icon && <item.icon width={item.width} height={item.height}/>}
						<div className={styles['item-link']} data-aid={item['dataAid']}>
							{item.text}
						</div>
					</Link>)}
			</li>);
        };
        this.renderStoreLink = (styles) => {
            const { store } = this.props;
            const link = store && store['store-link'];
            return (link &&
                store && (<li className={styles['links-item']}>
					<a className={styles['link']} href={store['store-link']} target="_blank" rel="noopener noreferrer">
						<div className={styles['item-link']}>{store['store-name']}</div>
					</a>
				</li>));
        };
        this.getMenuDropDown = (styles) => {
            return (<ul className={styles['links']}>
				{HELP_LINKS.map((item, i) => {
                return this.renderLink(item, i, styles);
            })}
				{this.renderStoreLink(styles)}
			</ul>);
        };
        this.handleMenuToggle = (show) => () => {
            this.setState({
                showMenuDropDown: show
            });
        };
        this.state = {
            showMenuDropDown: false
        };
    }
    render() {
        const { coBrandStyles } = this.props;
        const styles = Object.assign({}, defaultStyles, coBrandStyles);
        const position = DropDownPosition.CENTER;
        const content = <div className={styles['account-name']}> {stringTemplate('more')} </div>;
        return (<div className={styles['item-container']} onMouseEnter={this.handleMenuToggle(true)} onClick={this.handleMenuToggle(!this.state.showMenuDropDown)} onMouseLeave={this.handleMenuToggle(false)}>
				<Dropdown position={position} fixPosition contentMaxWidth={DROP_MENU_MAX_WIDTH} content={content} active={this.state.showMenuDropDown} className={styles['drop-menu']} tooltipClassName={styles['dropdown-container']} containerClassName={styles['dropdown-inner-container']}>
					{this.getMenuDropDown(styles)}
				</Dropdown>
				<Chevron width={4.7} height={8} className={cx(styles['chevron'], { [styles['active']]: this.state.showMenuDropDown })} pathClassName={styles['chevron-path']}/>
			</div>);
    }
}
export default withRouter(HelpMenuDropDown);
